export default {
  'main-menu.cases.title': 'Случаи',
  'main-menu.cases-create.title': 'Новый запрос',
  'main-menu.cases-creation-orders.title': 'Запросы на исследование',
  'main-menu.logout.title': 'Выход',
  'main-menu.code-scanner-status.tooltip': 'Для ускорения работы вы можете считывать коды материалов сканером',
  'main-menu.guide-button.tooltip': 'Пользовательская инструкция',

  'common.phrases.yes': 'Да',
  'common.phrases.no': 'Нет',
  'common.autocomplete.noDataText': 'Ничего не найдено',
  'common.bytes': 'Байт',
  'common.byte': 'Байт',
  'common.kb': 'КБ',
  'common.mb': 'МБ',
  'common.gb': 'ГБ',
  'common.tb': 'ТБ',

  'cases.materials.tissue': 'Сырой материал в формалине',
  'cases.materials.tissues': 'Сырые материалы в формалине',
  'cases.materials.block': 'Гистологический блок',
  'cases.materials.blocks': 'Гистологические блоки',
  'cases.materials.slide': 'Гистологический препарат',
  'cases.materials.slides': 'Гистологические препараты',
  'cases.materials.document': 'Бумажный документ',
  'cases.materials.documents': 'Бумажные документы',
  'cases.materials.file': 'Электронный носитель информации',
  'cases.materials.files': 'Электронные носители информации',

  'cases.filters.title': 'Фильтры',
  'cases.filters.statuses.label': 'Выберите статусы',
  'cases.filters.services.label': 'Выберите услуги',
  'cases.filters.services.no-data.label': 'Подходящих услуг не найдено',
  'cases.filters.specialists.label': 'Выберите специалиста',
  'cases.filters.specialists.no-data.label': 'Подходящих специалистов не найдено',
  'cases.filters.creationDatetime.label': 'Период создания',
  'cases.filters.creationDatetime.start.label': 'С даты ',
  'cases.filters.creationDatetime.end.label': 'По дату ',
  'cases.filters.fulltextSearch.label': 'Поиск по названию / имени пациента / коду клиента',

  'cases.table.columns.header.title': 'Название',
  'cases.table.columns.header.creationDatetime': 'Дата создания',
  'cases.table.columns.header.receiptMaterialsDatetime': 'Дата получения материалов',
  'cases.table.columns.header.reportValidatedAt': 'Дата валидации',
  'cases.table.columns.header.status': 'Статус',
  'cases.table.columns.header.services': 'Услуги',
  'cases.table.columns.header.report': 'Заключение',
  'cases.table.columns.header.patientName': 'Имя пациента',
  'cases.table.columns.header.externalLabel': 'Код клиента',
  'cases.table.columns.header.clientSpecialist': 'Направляющий врач',
  'cases.table.columns.header.price': 'Стоимость',
  'cases.table.noResultText': 'Нет случаев, удовлетворяющих критериям поиска',
  'cases.table.itemsPerPage': 'Случаев на странице',
  'cases.showReport': 'Просмотр заключения',
  'caseDetails.case.title': 'Случай',
  'caseDetails.caseInDp.label': 'Случай в DP',
  'caseDetails.caseCreationDatetime.label': 'Дата создания',
  'caseDetails.periodExecution.label': 'Срок выполнения',
  'caseDetails.receiptMaterialsDatetime.label': 'Дата получения материалов',
  'caseDetails.materialsReturnedDate.label': 'Дата возврата материалов',
  'caseDetails.patientName.label': 'Имя пациента',
  'caseDetails.patientPhone.label': 'Телефон пациента',
  'caseDetails.patientAddress.label': 'Адрес пациента',
  'caseDetails.patientEmail.label': 'Email пациента',
  'caseDetails.outgoingDiagnosis.label': 'Исходящий диагноз',
  'caseDetails.price.label': 'Стоимость',
  'caseDetails.clientSpecialist.label': 'Направляющий врач',
  'caseDetails.holdHistory.label': 'История приостановок исследований',
  'caseDetails.holdHistory.start.label': 'Начало',
  'caseDetails.holdHistory.finish.label': 'Конец',
  'caseDetails.holdHistory.reason.label': 'Причина',
  'caseDetails.ecdcHistory.label': 'История корректировок времени завершения исследования',
  'caseDetails.ecdcHistory.date.label': 'Дата',
  'caseDetails.ecdcHistory.hours.label': 'Часы',
  'caseDetails.ecdcHistory.reason.label': 'Причина',
  'caseDetails.holdHistory.noHistory.label': 'Нет истории',
  'caseDetails.ecdcHistory.noHistory.label': 'Нет истории',
  'cases.showReport.case.title': 'Случай',
  'cases.showReport.sentAt.title': 'Заключение было отправлено',
  'cases.showReport.downloadButton.title': 'Загрузить',
  'cases.showReport.downloadButton.titleNoHeader': 'Загрузить без шапки',

  'createCase.title': 'Регистрация запроса на исследование',

  'caseCreationOrderForm.fields.patientName.label': 'ФИО',
  'caseCreationOrderForm.fields.patientGender.label': 'Пол',
  'caseCreationOrderForm.fields.patientGender.options.male': 'М',
  'caseCreationOrderForm.fields.patientGender.options.female': 'Ж',
  'caseCreationOrderForm.fields.patientBirthday.label': 'Дата рождения',
  'caseCreationOrderForm.fields.patientBirthday.placeholder': 'ДД.ММ.ГГГГ',
  'caseCreationOrderForm.fields.patientAddress.label': 'Адрес',
  'caseCreationOrderForm.fields.patientPhone.label': 'Телефон',
  'caseCreationOrderForm.fields.patientEmail.label': 'Email',
  'caseCreationOrderForm.fields.patientMedicalInsurance.label':'Полис ОМС',
  'caseCreationOrderForm.fields.patientSnils.label': 'СНИЛС пациента',
  'caseCreationOrderForm.fields.patientRegistrationPlace.label': 'Местность',
  'caseCreationOrderForm.fields.patientPlace.options.COUNTRY': 'Сельская',
  'caseCreationOrderForm.fields.patientPlace.options.CITY': 'Городская',
  'caseCreationOrderForm.fields.clinicalData.label': 'Значимые клинические данные',
  'caseCreationOrderForm.fields.examination.label': 'Задача исследования',
  'caseCreationOrderForm.fields.receiveMaterialMethod.label': 'Способ получения материала',
  'caseCreationOrderForm.fields.receiveMaterialMethod.options.endoscopic': 'эндоскопическая биопсия',
  'caseCreationOrderForm.fields.receiveMaterialMethod.options.needle': 'пункционная биопсия',
  'caseCreationOrderForm.fields.receiveMaterialMethod.options.aspiration': 'аспирационная биопсия',
  'caseCreationOrderForm.fields.receiveMaterialMethod.options.incisional': 'инцизионная биопсия',
  'caseCreationOrderForm.fields.receiveMaterialMethod.options.excisional': 'операционная биопсия',
  'caseCreationOrderForm.fields.receiveMaterialMethod.options.surgical': 'операционный материал',
  'caseCreationOrderForm.fields.receiveMaterialMethod.options.shed': 'самопроизвольно отделившиеся фрагменты тканей',
  'caseCreationOrderForm.fields.externalId.label': 'Внутренний идентификатор случая',
  'caseCreationOrderForm.fields.externalLabel.label': 'Код клиента (отобразится в заключении)',
  'caseCreationOrderForm.fields.diagnosis.label':'Диагноз',
  'caseCreationOrderForm.fields.icd10.label':'МКБ-10',
  'caseCreationOrderForm.fields.clientSpecialist.label': 'Направляющий врач',
  'caseCreationOrderForm.subtitle.services.label': 'Услуги',
  'caseCreationOrderForm.fields.services.serviceSelector.label': 'Выберите услугу',
  'services.headers.serviceTitle.label': 'Название',
  'services.headers.codeTitle.label': 'Код',
  'services.headers.clientCodeTitle.label': 'Код клиента',
  'services.headers.priceTitle.label': 'Цена',
  'services.headers.quantityTitle.label': 'Количество',
  'services.titleOrCodeFilter.label': 'Поиск по названию / коду',
  'services.selectedUpper.label': 'Выбранные сверху',
  'services.noSelected.label': 'Не выбрано ни одной услуги',

  'caseCreationOrderForm.subtitle.files.label': 'Файлы',

  'caseCreationOrderForm.subtitle.materials.label': 'Материалы на исследование',
  'caseCreationOrderForm.subtitle.additionalMaterials.label': 'Дополнительные материалы',
  'materials.creationForm.fields.type.label': 'Тип',
  'materials.creationForm.fields.code.label': 'Маркировка материала',
  'materials.creationForm.fields.code.hint': 'Маркировка указывается без лишних пробелов, строго как на этикетке',
  'materials.creationForm.fields.code.tooltip': 'Важно: Маркировка должна быть введена без пробелов, строго как на этикетке! Если это банка — боковая поверхность банки (на крышку запрещено!). Если это гистоблок — обратная поверхность блока. Если это стекло — место для этикетки.',
  'materials.creationForm.fields.fragments.label': 'Количество фрагментов',
  'materials.creationForm.fields.fragments.errors.required': 'Укажите количество фрагментов',
  'materials.creationForm.fields.fragments.errors.number': 'Количество фрагментов должно быть целым числом',
  'materials.creationForm.fields.fragments.errors.min': 'Количество фрагментов должно быть не меньше 1',
  'materials.creationForm.fields.description.label': 'Описание',
  'materials.creationForm.fields.type.errors.required': 'Выберите тип материала',
  'materials.creationForm.fields.code.errors.required': 'Укажите маркировку',
  'materials.creationForm.fields.code.errors.length': 'Маркировка должна быть не более 100 символов в длину',
  'materials.creationForm.fields.code.errors.exists': 'Материал с такой маркировкой уже существует. Введите другую маркировку',
  'materials.creationForm.fields.description.errors.required': 'Укажите описание',
  'materials.creationForm.fields.description.errors.length': 'Описание должно быть не более 200 символов в длину',
  'materials.creationForm.buttons.create.label': 'Добавить',
  'materials.creationForm.buttons.cancel.label': 'Отмена',
  'materials.subtitle.tissues': 'Сырые материалы в формалине',
  'materials.subtitle.blocks': 'Гистологические блоки',
  'materials.subtitle.slides': 'Гистологические препараты',
  'materials.subtitle.documents': 'Бумажные документы',
  'materials.subtitle.files': 'Электронные носители информации',
  'materials.buttons.addMaterial.title': 'Добавить материал',
  'createCase.buttons.create.label': 'Создать',
  'createCase.buttons.toDraft.label': 'Черновик',
  'createCase.buttons.toValidation.label': 'На валидацию',
  'createCase.buttons.clear.label': 'Очистить',

  'files.buttons.uploadFile.title': 'Приложить файлы',
  'files.sent.title': 'Отправлен в лабораторию',
  'files.errors.unableToUploadFile': 'Не удалось загрузить файл, повторите попытку',

  'caseCreationOrderForm.fields.patientName.errors.required': 'Введите имя пациента',
  'caseCreationOrderForm.fields.patientName.errors.length': 'Имя не должно быть длиннее 50 символов',
  'caseCreationOrderForm.fields.patientGender.errors.required': 'Выберите пол пациента',
  'caseCreationOrderForm.fields.patientBirthday.errors.required': 'Укажите дату рождения пациента',
  'caseCreationOrderForm.fields.patientBirthday.errors.invalid': 'Укажите корректную дату в формате ДД.ММ.ГГГГ',
  'caseCreationOrderForm.fields.patientAddress.errors.length': 'Адрес не должен быть длиннее 100 символов',
  'caseCreationOrderForm.fields.patientPhone.errors.length': 'Номер телефона не должен быть длиннее 25 символов',
  'caseCreationOrderForm.fields.patientEmail.errors.length': 'Email не должен быть длиннее 50 символов',
  'caseCreationOrderForm.fields.patientMedicalInsurance.errors.length': 'Номер полиса должен содержать 16 цифр',
  'caseCreationOrderForm.fields.patientMedicalInsurance.errors.format': 'Номер полиса должен содержать ровно 16 цифр или быть пустым',
  'caseCreationOrderForm.fields.snils.errors.length': 'Номер СНИЛС не должен быть длиннее 11 символов',
  'caseCreationOrderForm.fields.snils.errors.valid': 'СНИЛС указан неверно',
  'caseCreationOrderForm.fields.diagnosis.errors.required': 'Укажите диагноз',
  'caseCreationOrderForm.fields.diagnosis.errors.length': 'Диагноз не должен превышать 200 символов',
  'caseCreationOrderForm.fields.clinicalData.errors.length': 'Клинические данные не должны превышать 10000 символов',
  'caseCreationOrderForm.fields.externalId.errors.length': 'Внутренний идентификатор случая не должен превышать 1000 символов в длину',
  'caseCreationOrderForm.fields.externalLabel.errors.length': 'Код клиента не должен превышать 1000 символов в длину',
  'caseCreationOrderForm.fields.material_sampling.label': 'Дата и время забора материала',
  'caseCreationOrderForm.messages.unableToCreate': 'Не удалось создать случай',
  'caseCreationOrderForm.messages.backendValidationErrors': 'Некоторые поля заполнены некорректно',
  'caseCreationOrderForm.messages.successCreate': 'Ваш запрос на исследование успешно отправлен.',
  'caseCreationOrderForm.requiredSections.files': 'Необходимо прикрепить хотя бы один файл',
  'caseCreationOrderForm.requiredSections.materials': 'Необходимо добавить хотя бы один материал',
  'caseCreationOrderForm.requiredSections.services': 'Необходимо выбрать хотя бы одну услугу',

  'caseCreationOrders.filters.statuses.label': 'Выберите статусы',
  'caseCreationOrders.filters.creationDatetime.label': 'Период создания',
  'caseCreationOrders.filters.creationDatetime.start.label': 'С даты  ',
  'caseCreationOrders.filters.creationDatetime.end.label': 'По дату ',

  'caseCreationOrders.table.columns.header.id': '#',
  'caseCreationOrders.table.columns.header.createdAt': 'Дата создания',
  'caseCreationOrders.table.columns.header.caseTitle': 'Идентификатор случая UNIM',
  'caseCreationOrders.table.columns.header.patientName': 'Пациент',
  'caseCreationOrders.table.columns.header.specialist': 'Специалист',
  'caseCreationOrders.table.columns.header.status': 'Статус',
  'caseCreationOrders.table.columns.header.blank': 'Бланк',
  'caseCreationOrders.table.blank.button': 'Бланк',
  'caseCreationOrders.messages.unableToGenerateBlank': 'Не удалось сформировать бланк',
  'caseCreationOrders.messages.successCancel': 'Запрос успешно отменен',
  'caseCreationOrders.messages.successDecline': 'Запрос успешно отклонен',

  'createCaseCreationOrders.messages.materialCreationSuggest': 'Код нового материала заполнен. Для завершения добавления выберите тип материала.',
  'createCaseCreationOrders.messages.materialIsAlreadyExists': 'Материал с таким кодом уже существует. Отсканируйте другой код',
  'createCaseCreationOrders.messages.caseCreationOrderFound': 'Осуществлен переход к заявке на исследование по материалу с кодом: ',

  'updateCaseCreationOrder.title': 'Редактирование запроса на исследование',
  'updateCaseCreationOrder.status': 'Статус',
  'updateCaseCreationOrder.declineReason': 'Причина отказа',
  'updateCaseCreationOrder.links.backToCaseCreationOrders': 'К списку запросов',
  'updateCaseCreationOrder.buttons.toDiagnostics.label': 'Отправить на диагностику',
  'updateCaseCreationOrder.buttons.update.label': 'Сохранить изменения',
  'updateCaseCreationOrder.buttons.toValidation.label': 'Отправить на валидацию',
  'updateCaseCreationOrder.buttons.decline.label': 'Отклонить',
  'updateCaseCreationOrder.buttons.cancel.label': 'Отменить',
  'updateCaseCreationOrder.messages.cancelConfirmation': 'Вы уверены, что ходитите отменить заявку',
  'updateCaseCreationOrder.decline.title': 'Отлонение запроса',
  'updateCaseCreationOrder.decline.errors.required': 'Укажите причину отказа',
  'updateCaseCreationOrder.decline.errors.length': 'Причина отказа должна быть не более 2000 символов',
  'updateCaseCreationOrder.decline.buttons.ok.label': 'Ok',
  'updateCaseCreationOrder.decline.buttons.cancel.label': 'Отмена'

}
